import React from 'react'
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card'

/**
 * ImageLinkCell - 图片链接展示组件
 * @param {string} link - 图片链接
 * @param {string} label - 标签名称（用于 hover 卡片标题）
 * @param {string} alt - 图片 alt 文本
 * @param {string} className - 自定义样式类名
 */
const ImageLinkCell = ({ url, label, alt, className = '' }) => {
  if (!url) {
    return <div className="text-muted-foreground">-</div>
  }

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <div className="cursor-pointer">
          <img
            src={url}
            alt={alt || label}
            className={`h-16 w-16 object-cover rounded-md border hover:ring-2 hover:ring-primary transition-all ${className}`}
            onError={(e) => {
              e.target.src =
                'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="64" height="64"%3E%3Crect width="64" height="64" fill="%23ccc"/%3E%3Ctext x="32" y="32" text-anchor="middle" dy=".3em" fill="%23999" font-size="10"%3ENo Image%3C/text%3E%3C/svg%3E'
            }}
          />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-80">
        <div className="space-y-2">
          <div className="text-sm font-semibold">{label}</div>
          <div className="text-xs text-muted-foreground break-all">{url}</div>
          <img
            src={url}
            alt={`${label} preview`}
            className="w-full h-auto rounded-md border"
            onError={(e) => {
              e.target.style.display = 'none'
            }}
          />
        </div>
      </HoverCardContent>
    </HoverCard>
  )
}

export default ImageLinkCell
